import { Iodine } from '@kingshott/iodine'

const iodine = new Iodine()

iodine.addRule('accept', (files, param) => {
	let accepts = param.replace(/\s/g, '').split(',').map((accept) => new RegExp(accept.replace('*', '.*')));

	return [...files].every((file) => {
		return accepts.filter((accept) => accept.test(file.type)).length > 0;
	})
});

iodine.addRule('equals', (value, param) => {
	return value == (document.getElementById(param)?.value);
});

iodine.addRule('maxsize', (files, param) => {
	let maxsize = +param;

	return [...files].every((file) => {
		return file.size <= maxsize;
	});
});

iodine.setErrorMessages({
	equals: 'Must be equal to [PARAM].',
	accept: 'File type not accepted.',
	maxsize: 'File exceeds the max upload size.',
})

export default () => ({
	inputs: {},

	init() {
		this.$el.querySelectorAll('[data-rules]').forEach((input) => {
			this.inputs[input.name] = {
				element: input,
				message: '',
				dirty: false,
			};
		});
	},

	validateForm() {
		let valid = true;

		Object.keys(this.inputs).forEach((name) => {
			// All inputs are made dirty by the attempted submission.
			this.inputs[name].dirty = true

			// Determine if the field is valid.
			let _valid = this.validate(this.inputs[name].element);

			// If there has not yet been an invalid field, mark the form as invalid and scroll the first invalid field into view.
			if (valid && !_valid) {
				valid = false;

				this.inputs[name].element.scrollIntoView({ block: 'center' });
			}
		})

		if (valid === true) {
			window?.FBPrecaptcha?.execute?.();
		}
	},

	validate($el) {
		let error = iodine.is($el.value, JSON.parse($el.dataset.rules));

		// If it's still valid and it's a file input type, run some extra tests on it.
		if (error === true && $el.type === 'file') {
			let rules = [];

			if ($el.accept) {
				rules.push(`accept:${$el.accept}`);
			}

			if ($el.dataset.fileMaxsize) {
				rules.push(`maxsize:${$el.dataset.fileMaxsize}`);
			}

			if (rules.length > 1) {
				error = iodine.is($el.files, rules);
			}
		}

		this.updateErrorMessage($el, error);

		return error === true;
	},

	updateErrorMessage($el, error) {
		let message = '';

		if (error !== true && this.inputs[$el.name].dirty) {
			let [, err, param] = error.match(/(\w+):?(\S+)?/);

			message = err in $el.dataset ? $el.dataset[err] : iodine.getErrorMessage(error);
		}

		this.inputs[$el.name].message = message;
	},

	submit() {
		this.$refs.form.submit();
	},

	onInput(e) {
		// Ignore elements we're not tracking
		if (!this.inputs[e.target.name]) {
			return;
		}
		this.validate(e.target);
	},

	onFocusout(e) {
		// Ignore elements we're not tracking
		if (!this.inputs[e.target.name]) {
			return;
		}
		this.inputs[e.target.name].dirty = true;
		this.validate(e.target);
	},
})
